<template>
    <div>
      <h2>위험도 분석</h2>
      <p>
        학원관리>위험도분석 메뉴에서 관리합니다.<br/>
        Tens에듀는 <span class="bg-yellow-13">학생의 학습활동을 AI가 자동</span>으로 분석합니다. 그 결과 <span class="bg-light-green-13">퇴원 위험도</span>를 분석합니다.<br/>
        퇴원 위험도는 학생에 대한 정보가 많을수록 더 정확합니다.<br/>
        즉, 학생의 출결 / 숙제 / 시험 / 상담수 / 상담 내용 등을 활용하여 AI가 분석한 결과입니다.<br/>
        퇴원 위험도는 매일 새벽 2시에 자동 분석하지만 필요에 따라 수동으로 재계산하도록 할 수 있습니다.<br/>
      </p>
      
      <section>
        <div class="p-relative section_0" id="drop_rate">
            <div class="ft-b">1)    위험도 분석</div>
        
            <div class="p-relative section_2">
                <div><img src="@/assets/aca/manual/stat/stat_drop_rate.jpg" /></div>
            </div>
            
        </div>

        
      </section>

      <q-drawer show-if-above side="right" class="bg-white">
          <q-list>
            <q-item-label header style="padding:40px 42px 20px;">바로가기</q-item-label>
            <li class="q-px-lg pointer" 
                      v-for="m in menuItems" 
                      :key="m.label"
                      @click="goTo(m.link)" >
                {{m.label}}
            </li>
            
          </q-list>
      </q-drawer>
    </div>
</template>

<script>
import goto from "./goto.js";
export default {
    components : {
    },
    data : function() {
        return {
            menuItems: [
                { label: '위험도 분석', link: '#drop_rate' },
            ]
        }
    },
    computed :{
    },
    methods : {
        goTo(link) {
            goto.goto_link(link);
        }
    },
    beforeMount() {
        goto.clear();
    }
}
</script>


